export default "__VITE_ASSET__DXsRu8mK__"